import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
import { useActions } from "@website/ui/datepicker/components/actions/actions.hook";
import styles from "@website/ui/datepicker/components/actions/actions.module.scss";
import { ActionsPropertiesType } from "@website/ui/datepicker/components/actions/actions.types";
import { FC } from "react";
export const Actions: FC<ActionsPropertiesType> = properties => {
  const $ = _c(8);
  const {
    calendarLocale: t0
  } = properties;
  const calendarLocale = t0 === undefined ? "gregorian" : t0;
  const {
    showTodayButtonProperties,
    changeCalendarLocaleButtonProperties
  } = useActions(properties);
  const t1 = calendarLocale === "persian" ? "\u0645\u06CC\u0644\u0627\u062F\u06CC" : "\u067E\u0627\u0631\u0633\u06CC";
  let t2;
  if ($[0] !== changeCalendarLocaleButtonProperties || $[1] !== t1) {
    t2 = <Button {...changeCalendarLocaleButtonProperties}>تبدیل به {t1}</Button>;
    $[0] = changeCalendarLocaleButtonProperties;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== showTodayButtonProperties) {
    t3 = <Button {...showTodayButtonProperties}>امروز</Button>;
    $[3] = showTodayButtonProperties;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className={styles.container}>{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};